import { onMounted, ref } from "vue"
import GTMregisterTotalkredit from '../PIMap/methods/GTMregisterTotalkredit'

export default {
    name: "CardMediumPI",
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        dropdownLabel: {
            type: String,
            default: ''
        },
        piPartners: {
            type: Array,
            default: []
        },
        color: {
            type: String,
            default: ''
        }
    },
    setup(props) {  
        const selectRef = ref(null)
        const classNameColor = `nyk-card-medium${props.color}`

        function getTextWidth(text, font) {
            // Create a canvas element
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            // Set the font
            context.font = font;
            // Measure the text
            const metrics = context.measureText(text);
            return metrics.width;
        }

        const reDrawSelectSize = () => {
            const optionText = selectRef.value.options[selectRef.value.selectedIndex].text
            const fontFamily = getComputedStyle(selectRef.value).fontFamily
            const fontSize = parseFloat(getComputedStyle(selectRef.value).fontSize)
            const font = `${fontSize}px ${fontFamily}`
            selectRef.value.style.width = `${getTextWidth(optionText, font) + 40}px`
        }

        onMounted(() => {
            reDrawSelectSize()
        })
        
        const onChange = () => {
            reDrawSelectSize()
            const index = selectRef.value.value
            const pi = props.piPartners[index]
            
            if (pi) {
                trackClickEvent(pi.name, pi.isExternal)
                if (pi.url) {
                    window.location.href = pi.url
                }
            }
        }

        const trackClickEvent = (piName, isExternal) => {
            GTMregisterTotalkredit(
                'CardGalleryMapBlock',
                'gå til website - click', 
                piName, 
                isExternal ? "udenfor samarbejdet" : "indenfor samarbejdet", 
                piName
            )
        }

        return {
            selectRef,
            classNameColor,
            onChange
        }
    }
}